import React from 'react'

import { UserRoles } from 'shared/consts'
import useLogin from 'shared/store/useLogin'

interface Props {
   wholesalerName: string
   wholesalerUuid: string
   imgHeight: string
   imgWidth: string
}

export default function HiddenWholesalerLogo({ wholesalerName, wholesalerUuid, imgHeight, imgWidth }: Props) {
   const { user } = useLogin()

   if (user.roles.includes(UserRoles.SALES_REP)) {
      return <span>{wholesalerName}</span>
   }
   return (
      <img
         src={`https://files.motorro.eu/img/logos-wholesalers/light/${wholesalerUuid}.png`}
         height={imgHeight}
         width={imgWidth}
         alt={wholesalerName}
      />
   )
}
